import { useMemoizedFn } from 'ahooks';
import React, { useEffect, useState } from 'react';
import {
  Button,
  Form,
  Input,
  Link,
  MessagePlugin,
  Popconfirm,
  Select,
  Space,
  Table,
  Tag,
} from 'tdesign-react';
import ListPanel from '@/components/ListPanel';
import useTable from '@/hooks/useTable';
import { deleteInspect, getInspectList } from '@/services/inspectService';
import { renderDateTime, toTsOptions } from '@/utils/common';
import PermWrapper from '@/components/PermWrapper';
import { checkTypeOptions } from '@/utils/constant';
import FormModal from './FormModal';

const { FormItem } = Form;

export default function Inspect() {
  const [visible, setVisible] = useState(false);
  const [detail, setDetail] = useState();

  const columns = [
    {
      title: '巡检模块',
      colKey: 'metricsMode',
      cell: ({ row }) => (
        <Tag
          variant='dark'
          size='small'
          theme='success'
          style={{ backgroundColor: '#4dc592', fontWeight: 500 }}
        >
          {row.metricsMode}
        </Tag>
      ),
      width: 140,
    },
    {
      title: '巡检名称',
      colKey: 'metricsName',
      ellipsis: true,
    },
    {
      title: '巡检规则',
      colKey: 'metricsRules',
      ellipsis: true,
    },
    {
      title: '阈值',
      colKey: 'threshold',
      width: 120,
    },
    {
      title: '巡检说明',
      colKey: 'metricsDescription',
      ellipsis: true,
    },
    {
      title: '创建时间',
      colKey: 'createTime',
      cell: renderDateTime,
      width: 180,
    },
    {
      title: '更新时间',
      colKey: 'updateTime',
      cell: renderDateTime,
      width: 180,
    },
    {
      colKey: 'option',
      title: '操作',
      fixed: 'right',
      cell: ({ row }) => (
        <Space>
          <PermWrapper resource='pulsar:sys:rules:update'>
            <Link
              theme='primary'
              onClick={() => {
                setDetail(row);
                setVisible(true);
              }}
              hover='color'
            >
              编辑
            </Link>
          </PermWrapper>
          <PermWrapper resource='pulsar:sys:rules:delete'>
            <Popconfirm theme='danger' content='确定删除？' onConfirm={() => doDelete(row)}>
              <Link theme='danger' hover='color'>
                删除
              </Link>
            </Popconfirm>
          </PermWrapper>
        </Space>
      ),
      width: 120,
    },
  ];

  const loadData = useMemoizedFn(async (params) => {
    const { data } = await getInspectList(params); // api分页无效，暂认为假分页
    setData(data.items, data.count);
  });

  const { setData, doSearch, config, header, doRefresh } = useTable({
    columns,
    search: (
      <>
        <FormItem name='metricsMode'>
          <Select
            options={toTsOptions(checkTypeOptions)}
            filterable
            clearable
            placeholder='请选择巡检模块'
          />
        </FormItem>
        <FormItem name='metricsName'>
          <Input clearable placeholder='请输入巡检名称' />
        </FormItem>
      </>
    ),
    onSearch: loadData,
    remote: true,
    operators: (
      <PermWrapper resource='pulsar:sys:rules:create'>
        <Button onClick={() => setVisible(true)}>新增巡检</Button>
      </PermWrapper>
    ),
  });

  useEffect(() => {
    doSearch();
  }, [doSearch]);

  const handleClose = (refresh) => {
    setVisible(false);
    setDetail(null);
    if (refresh) {
      doRefresh();
    }
  };

  const doDelete = async ({ id }) => {
    try {
      await deleteInspect(id);
      MessagePlugin.success('删除成功');
      doRefresh();
    } catch (error) {
      console.trace(error);
      throw error;
    }
  };

  return (
    <ListPanel header='巡检指标'>
      {header}
      <Table {...config} />
      <FormModal detail={detail} visible={visible} handleClose={handleClose} />
    </ListPanel>
  );
}
